import {ReactComponent as NoOptimizedPlans} from '@hconnect/uikit/src/lib2/components/comment/noComments.svg'
import {BaseErrorPage} from '@hconnect/uikit/src/lib2/pages/BaseErrorPage'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {RouteName} from '../../../routing'
import {PlannerPageLayout} from '../../../shared/components/PlannerPageLayout'
import {pageDataTestId} from '../../../shared/formatutils'
import {StartRecalculationButton} from '../shared/StartRecalculationButton'

export const PageNoOptimizedPlans: React.FC = () => {
  const {t} = useTranslation()

  return (
    <PlannerPageLayout
      isTourBannerEnabled={true}
      title={t('navItems.optimizer')}
      pageTitle={t('navItems.optimizer')}
      sx={{display: 'flex', flexDirection: 'column'}}
      nameBodySx={{flexGrow: 1, justifyContent: 'center', alignContent: 'center'}}
      {...pageDataTestId(RouteName.OPTIMIZER_NO_PLANS)}
    >
      <BaseErrorPage
        illustration={<NoOptimizedPlans />}
        caption={t('optimizer.noOptimizedPlans')}
        description={t('optimizer.noOptimizedPlansDescription')}
        dataTestId="no_optimized_plans_placeholder"
      >
        <StartRecalculationButton backgroundMode="medium" />
      </BaseErrorPage>
    </PlannerPageLayout>
  )
}
